module.exports = __webpack_public_path__ + "static/media/hand2.21e72623.bin";